export const getQueryStringAsObj = queryString => {
	const paramsObj = {};

	if (
		queryString !== null &&
		queryString !== undefined &&
		typeof queryString === 'string' &&
		queryString !== '' &&
		queryString.trim() !== ''
	) {
		const searchParams = new URLSearchParams(queryString);

		for (const [key, value] of searchParams.entries()) {
			if (Object.prototype.hasOwnProperty.call(paramsObj, key)) {
				if (!Array.isArray(paramsObj[key])) {
					paramsObj[key] = [paramsObj[key]];
				}
				paramsObj[key].push(value);
			} else {
				paramsObj[key] = value;
			}
		}
	}

	return paramsObj;
};
